'use client';

import * as React from 'react';
import { Input, Label, TextField } from '@heroui/react';

function normalizeHexForInput(hex: string): string {
  const t = hex.trim();
  if (!t) return '#000000';
  const withHash = t.startsWith('#') ? t : `#${t}`;
  if (/^#[0-9a-f]{6}$/i.test(withHash)) return withHash.toUpperCase();
  if (/^#[0-9a-f]{3}$/i.test(withHash)) {
    const h = withHash.slice(1);
    return (`#${h[0]}${h[0]}${h[1]}${h[1]}${h[2]}${h[2]}`).toUpperCase();
  }
  return '#000000';
}

export type HexColorControlProps = {
  /** 受控颜色值（hex，如 #RRGGBB） */
  value: string;
  onChange: (hex: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  /** 兼容旧 ColorPicker：无 UI 差异时忽略 */
  showModeToggle?: boolean;
};

/**
 * 画布属性面板用纯色选择：文本输入 + 系统取色器，替代 `@hs/ui` ColorPicker。
 */
export function HexColorControl({
  value,
  onChange,
  placeholder = '#000000',
  disabled = false,
  className,
}: HexColorControlProps) {
  const native = normalizeHexForInput(value || '#000000');

  return (
    <TextField isDisabled={disabled} className={className}>
      <Label className="sr-only">颜色</Label>
      <div className="flex items-center gap-2">
        <Input
          className="min-w-0 flex-1 font-mono text-sm"
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
        />
        <input
          type="color"
          aria-label="打开取色器"
          disabled={disabled}
          value={native}
          onChange={(e) => onChange(e.target.value.toUpperCase())}
          className="size-9 shrink-0 cursor-pointer rounded-md border border-divider bg-surface p-0 disabled:cursor-not-allowed disabled:opacity-50"
        />
      </div>
    </TextField>
  );
}
